module.exports = __webpack_public_path__ + "static/media/end-card-explorations.748bea38.gif";